import React, {useCallback} from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import DataSetCard from "../../theme/card/DataSetCard";
import {PAGE_SIZE, useTable} from "common/src/hooks/table/tableHook";
import {constructPage} from "common/src/utils/APIUtils";
import useUpdateOnlyEffect from "common/src/hooks/effect/useUpdateOnlyEffect";
import TablePagination from "common/src/components/widget/TablePagination";
import TableFilter from "common/src/components/widget/TableFilter";
import Loader from "common/src/components/widget/Loader";

const PageableDataCards = (props) => {
    const {
        refreshState: refreshDependantState,
        cardTitle,
    } = props;
    const {t} = useTranslation();
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const tableData = useSelector(props.selector);
    const loading = props.loadingSelector ? useSelector(props.loadingSelector) : false;
    const fetchData = useCallback((page, filter, sort) => {
        return dispatch(props.fetchAction({
            page: page,
            filter: filter,
            sort: sort
        }));
    }, [dispatch, props.fetchAction]);

    const {
        refreshList,
        page,
        onPage,
        sort,
        onSort,
        onFilter,
        total,
        filter,
    } = useTable({
        total: tableData?.totalElements || 0,
        data: tableData ? tableData : {content: []},
        page: constructPage(0, PAGE_SIZE),
        filter: props.defaultFilter,
        sort: props.defaultSort
    }, () => {}, fetchData);
    const sortControls = {
        sortColumns: [
            // TODO
            { id:'name_asc', name: 'Name', key:'name', direction: 'asc' },
            { id:'name_desc', name: 'Name', key:'name', direction: 'desc' },
            { id:'description_asc', name: 'description',key:'description', direction: 'asc' },
            { id:'description_desc', name: 'description',key:'description', direction: 'desc' },
            // Add more sort column definitions as needed
        ],
        sortObj: sort || {},
        onSortChange: onSort
    };
    useUpdateOnlyEffect(() => {
        if (refreshDependantState !== undefined) {
            refreshList();
        }
    }, [refreshDependantState]);
    const cardContent = () => (
        <div className="card-content">
            {(props.filterColumns && props.filterColumns.length > 0) &&
                <div className="level marginless level-right">
                    <div>
                        <div className=" mb-5 ">
                            {props.filterColumns && props.filterColumns.length > 0 &&
                                <TableFilter
                                    title={t('title.filter')}
                                    columns={props.filterColumns}
                                    filter={filter}
                                    onFilter={onFilter}
                                    sortControls={sortControls}

                                />
                            }
                        </div>
                    </div>

                </div>
            }
            <div className="is-flex is-flex-wrap-wrap">
                {loading && <Loader loading={loading}/> }
                {!loading && tableData?.content?.map((item, index) => (
                    <div className="card-wrapper" key={index}>
                        {item && <DataSetCard data={item}/>}
                    </div>
                ))}
            </div>
            <div className='mt-4'>
                {tableData && tableData.totalElements > 0 && total > 0 &&
                    <TablePagination
                        page={page.page}
                        total={total}
                        pageSize={page.size}
                        onPage={onPage}
                    />
                }
            </div>
        </div>
);
    return (
        <>
            {!cardTitle && props.title && <h2>{props.title}</h2>}
            {cardContent()}
        </>
    );

}

PageableDataCards.propTypes = {
    selector: PropTypes.func.isRequired,
    loadingSelector: PropTypes.func,
    fetchAction: PropTypes.func.isRequired,
    defaultSort: PropTypes.string,
    sortColumns: PropTypes.arrayOf(PropTypes.object),
    filterColumns: PropTypes.arrayOf(PropTypes.object),
    defaultFilter: PropTypes.string,
    cardTitle: PropTypes.string,
    refreshState: PropTypes.bool,
}

export default PageableDataCards;
